export const REFRESH_BROADCAST_DONE_TOAST = {
  color: 'green',
  message: 'המסך רוענן: הרענון נשלח לכל המכשירים',
  autoClose: 3000,
} as const;

export const REFRESH_BROADCAST_FAILED_TOAST = {
  color: 'red',
  title: 'שגיאה',
  message: 'שליחת הרענון נכשלה',
  autoClose: 3000,
} as const;

export const REFRESH_MANAGER_NOW_TOAST = {
  color: 'blue',
  message: 'המנהל ביקש רענון — מרענן…',
  autoClose: 3000,
} as const;

export const REFRESH_MANAGER_DEFERRED_TOAST = {
  color: 'orange',
  message: 'המנהל ביקש רענון — יבוצע בסיום הפעולה',
  autoClose: 3000,
} as const;

export const REFRESH_SELF_DEFERRED_TOAST = {
  color: 'orange',
  message: 'הרענון יבוצע בסיום הפעולה הנוכחית',
  autoClose: 3000,
} as const;

export const REFRESH_DONE_TOAST = {
  color: 'green',
  message: 'המסך רוענן',
  autoClose: 3000,
} as const;

// sessionStorage key + values for the post-reload notice (a reload destroys any pre-reload toast).
export const REFRESH_NOTICE_KEY = 'pos.refreshNotice';
export type RefreshNotice = 'now' | 'deferred';
// Marks the broadcast initiator (timestamp) so it shows ONE combined toast post-reload.
export const REFRESH_INITIATOR_KEY = 'pos.refreshInitiator';
export const REFRESH_INITIATOR_MAX_AGE_MS = 120_000;
